export class RevalidateRestoreTemplateRequest {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "resourceId",
            "baseName": "resourceId",
            "type": "string",
            "format": "uuid"
        }
    ];
    static getAttributeTypeMap() {
        return RevalidateRestoreTemplateRequest.attributeTypeMap;
    }
    constructor() {
    }
}
